import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material';
import { AppRoutes } from '../routes';

const styling = {
  headingStyle: { fontWeight: 'bold' },
  linkStyle: {},
};

const capitalizeFirstLetter = (value?: string): string => {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  } else {
    return '';
  }
};

export const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const buildBreadcrumb = () => {
    const breadcrumbs: { path: string; name?: string }[] = [{ path: '/', name: 'Home' }];
    let currentPath = '';

    Array.isArray(pathnames) &&
      pathnames?.forEach((pathname) => {
        currentPath += `/${pathname}`;
        const matchingRoute = findMatchingRoute(currentPath, AppRoutes[0].children);
        if (matchingRoute) {
          breadcrumbs.push({ path: currentPath, name: matchingRoute.name ?? pathname });
        }
      });

    return breadcrumbs;
  };

  const findMatchingRoute = (path: string, routes: any[]): any | null => {
    const foundRoute = routes?.reduce((matchingRoute: any, route: any) => {
      const routePath = route.path ?? '';
      const pathSegments = path.split('/').filter((x: string) => x);
      const routePathSegments: string[] = routePath.split('/').filter((x: string) => x);

      if (routePathSegments.length > 0 && pathSegments.length > 0 && pathSegments.length >= routePathSegments.length) {
        const result = routePathSegments.every((rsegment: string, index: number) => {
          if (rsegment.startsWith(':')) {
            return true;
          }
          if (rsegment === pathSegments[index]) {
            return true;
          }
          return false;
        });

        if (result) {
          if (pathSegments.length === routePathSegments.length) {
            return route;
          }
          return findMatchingRoute(pathSegments.slice(routePathSegments.length).join('/'), route.children);
        }
      }

      return matchingRoute;
    }, null);

    return foundRoute;
  };

  const breadcrumbs = buildBreadcrumb();

  return (
    <Breadcrumbs className="breadcrumb" aria-label="breadcrumb">
      {breadcrumbs.map((breadcrumb) => (
        <Link key={breadcrumb.path} style={styling.linkStyle} to={breadcrumb.path}>
          {capitalizeFirstLetter(breadcrumb.name)}
        </Link>
      ))}
    </Breadcrumbs>
  );
};
